import { Injectable } from '@angular/core';
import { AwsApiService } from './aws-api.service';
import { LogService } from './log.service';
import { SessionStorageService } from './session-storage.service';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class PasswordService {
  constructor(
    private api: AwsApiService,
    private http: HttpClient,
    private log: LogService,
    private sessionStorage: SessionStorageService
  ) {}

  changePassword(
    oldPassword: string,
    newPassword: string,
    callback: Function,
    accessToken?: string
  ) {
    const api = environment.api.changePassword,
      body = {
        oldPassword: oldPassword,
        newPassword: newPassword,
        accessToken: accessToken || this.sessionStorage.getAccessToken(),
        userPoolId: this.sessionStorage.getOrganization().UserPoolId
      };

    this.http
      .post(api, body)
      .subscribe(data => callback(null, data), err => callback(err.error));
  }

  forgotPassword(username: string, callback: Function) {
    const api = environment.api.forgotPassword,
      body = { username: username };

    this.http
      .post(api, body)
      .subscribe(data => callback(null, data), err => callback(err.error));
  }

  confirmForgotPassword(
    username: string,
    code: string,
    new_password: string,
    callback: Function
  ) {
    const api = environment.api.confirmForgotPassword,
      body = {
        username: username,
        code: code,
        password: new_password
      };

    this.http
      .post(api, body)
      .subscribe(data => callback(null, data), err => callback(err.error));
  }
}
